export default "__VITE_ASSET__D7UyF6t0__"